import { Button } from "@mui/material";
import { useEffect } from "react";
import api from "../../api/PrivateApi";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function SendBackToReqCourses({
  course,
  getCourses,
  setshowOptiontosendback,
  setalertselfassignFailed,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
    disableScroll();

    return () => {
      enableScroll();
    };
  }, []);

  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  async function sendbackToRequestCourse() {
    let resp = await api.post(`courseallocation/sendbacktorequestedcourse`, {
      courseCode: course.course_code,
      curriculumId: course.Course_Curriculum.curriculum_id,
    });

    if (resp.data.msg == true) {
      getCourses();
      setshowOptiontosendback(false);
    } else if (resp.data.msg == false) {
      setshowOptiontosendback(false);
      setalertselfassignFailed(true);
      setTimeout(() => {
        setalertselfassignFailed(false);
      }, 10000);
    }
  }

  return (
    <div className="sendBackContainer">
      <div className="sendBackWrapper">
        <p style={{ textAlign: "right" }}></p>

        <h2 style={{ textAlign: "center", color: " #cd853f" }}>
          Send {course.course_name} back to Requested Courses
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            sx={{ marginLeft: "15px" }}
            onClick={() => {
              setshowOptiontosendback(false);
              enableScroll();
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{ marginLeft: "15px" }}
            onClick={() => {
              sendbackToRequestCourse();
            }}
          >
            Send Back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SendBackToReqCourses;
